/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.push.js";
import { showToast } from 'vant';
import localCache from '@/utils/localCache';
import useTotalData from './hooks/useTotalData';
import { useEmptyStringFormat } from '@/hooks/fn';
export default defineComponent({
  name: 'YieldCorrection',
  components: {},
  setup: function setup() {
    var formatDate = function formatDate(date) {
      return dayjs(date).format('YYYY/MM/DD');
    };
    var emptyStringFormat = useEmptyStringFormat();
    var route = useRoute();
    var defaultDate = ref('');
    if (route.params.date) {
      localCache.setItem('defaultDate', formatDate(new Date(route.params.date)));
    }
    var localCacheDefaultDate = localCache.getItem('defaultDate');
    if (localCacheDefaultDate) {
      defaultDate.value = localCacheDefaultDate;
    }
    provide('defaultDate', readonly(defaultDate));
    var params = ref({
      dayTime: dayjs().format('YYYY/MM/DD')
    });
    var btnDisabled = ref(false);
    if (defaultDate !== null && defaultDate !== void 0 && defaultDate.value) {
      params.value.dayTime = defaultDate.value;
    }
    var confirmDate = function confirmDate(value) {
      params.value.dayTime = formatDate(value);
      localCache.deleteItem('defaultDate');
      defaultDate.value = formatDate(value);
      findProductDayDataAsync();
    };
    var _useTotalData = useTotalData(params),
      _useTotalData2 = _slicedToArray(_useTotalData, 4),
      productDayData = _useTotalData2[0],
      summaryData = _useTotalData2[1],
      findProductDayDataAsync = _useTotalData2[2],
      updateProductDataAsync = _useTotalData2[3];
    var update = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(item) {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // if (item.new_net_weight > 30000) {
              //   showToast('已超过产线最大产量，请重新修改')
              //   return
              // }
              btnDisabled.value = true;
              _context.next = 3;
              return updateProductDataAsync([item]);
            case 3:
              res = _context.sent;
              showToast(res);
              btnDisabled.value = false;
              findProductDayDataAsync();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function update(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var router = useRouter();
    var lookLog = function lookLog() {
      router.push({
        name: 'ModifyRecords',
        params: {
          date: defaultDate.value
        }
      });
    };
    onMounted(function () {
      findProductDayDataAsync();
    });
    return {
      confirmDate: confirmDate,
      emptyStringFormat: emptyStringFormat,
      summaryData: summaryData,
      productDayData: productDayData,
      update: update,
      lookLog: lookLog,
      btnDisabled: btnDisabled
    };
  }
});